module.exports = __webpack_public_path__ + "static/media/picto-website.0a7da3e4.svg";